import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUndo } from '@fortawesome/free-solid-svg-icons';
import { CONTENT_TYPES, CLIENT_TYPES, DISTRIBUTIONS } from './constants';

export function ChannelsFilters({ filters, onChange, onSearch, onReset }) {
    return (
        <div className="filters-panel">
            <div className="row g-3 align-items-end">
                <div className="col-md-3">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Buscar</label>
                    <input
                        type="text"
                        className="form-control bg-dark text-white border-secondary py-2"
                        value={filters.q || ''}
                        placeholder="Nombre o alias..."
                        onChange={(e) => onChange('q', e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') onSearch(); }}
                    />
                </div>
                <div className="col-md-3">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Contenido</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={filters.content}
                        onChange={(e) => onChange('content', e.target.value)}
                    >
                        <option value="">Todos</option>
                        {CONTENT_TYPES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
                    </select>
                </div>
                <div className="col-md-2">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Estado</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={filters.active}
                        onChange={(e) => onChange('active', e.target.value)}
                    >
                        <option value="">Todos</option>
                        <option value="true">Activo</option>
                        <option value="false">Inactivo</option>
                    </select>
                </div>
                <div className="col-md-2">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Cliente</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={filters.client_type}
                        onChange={(e) => onChange('client_type', e.target.value)}
                    >
                        <option value="">Todos</option>
                        {CLIENT_TYPES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
                    </select>
                </div>
                <div className="col-md-2">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Distribución</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={filters.distribution}
                        onChange={(e) => onChange('distribution', e.target.value)}
                    >
                        <option value="">Todos</option>
                        {DISTRIBUTIONS.map((d) => <option key={d.value} value={d.value}>{d.label}</option>)}
                    </select>
                </div>
                <div className="col-12 d-flex gap-2">
                    <button className="btn btn-ink-search" onClick={onSearch}>
                        <FontAwesomeIcon icon={faSearch} className="me-1" /> Buscar
                    </button>
                    <button className="btn btn-outline-secondary border-secondary text-white-50 px-3" onClick={onReset}>
                        <FontAwesomeIcon icon={faUndo} className="me-1" /> Limpiar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ChannelsFilters;